import ActionsButton from 'components/tables/AGGrid/ActionsButton';

/**
 * Builds the AG Grid column definitions for the Voice Policies table.
 *
 * @param {object}   params
 * @param {function} params.onEditVoicePolicy  Called with the row data when the edit action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getVoicePoliciesTableColumns = ({ onEditVoicePolicy }) => [
    {
        headerName: 'Voice Policy',
        field: 'name',
        flex: 1,
        minWidth: 150,
        sort: 'asc',
    },
    {
        headerName: 'Pattern',
        field: 'pattern',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsButton
                actions={[
                    {
                        label: 'Edit Voice Policy',
                        onClick: () => onEditVoicePolicy(params.data),
                    },
                ]}
            />
        ),
    },
];
